<template>
    <div class="c-product-line c-product-line--customer" :class="{'is-open': open}">
        <button class="u-fullwidth u-text-align-left c-button--reset" @click="toggleProduct">
            <div class="c-product-line-header">
                <div v-if="product.Images && product.Images.length > 0" class="u-text-align-center">
                    <img :src="product.Images[0].replace('[WIDTH]', '60').replace('[HEIGHT]', '60')" alt="">
                </div>
                <template v-else>
                    <div v-if="product.HexCode" class="u-text-align-center">
                        <div class="c-product-color-element" v-bind:style="{ backgroundColor: product.HexCode}"></div>
                    </div>
                    <div v-else class="u-text-align-center">
                        <img src="@/assets/images/no_image.png" alt="">
                    </div>
                </template>
                <div>
                    <strong>{{ product.Color }}</strong><br>
                    <span>{{ product.ColorId }}</span>
                </div>
                <div class="c-product-line-header__item">
                    <em>{{ $t('product.detail.retail_price') }}</em>
                    <strong>{{ product.OriginalFromPrice | currency(customerCurrencySymbol) }}</strong>
                </div>
                <div v-if="!isCustomerHidden && !isMarketing" class="c-product-line-header__item">
                    <div>
                        <em>{{ $t('product.detail.article_price') }}</em>
                        <strong>{{ product.RetailFromPrice | currency(customerCurrencySymbol) }}</strong>
                    </div>
                </div>
                <div v-if="!isCustomerHidden && product.DiscountValue" class="c-product-line-header__item">
                    <em>{{ $t('product.detail.your_discount') }}</em>
                    <strong class="u-color-success-base">{{ product.DiscountPercentage }}%</strong>
                </div>
                <strong v-if="!isCustomerHidden && product.DiscountValue" class="c-product-line-header__item u-color-base-base">
                    <em>{{ $t('product.detail.your_price') }}</em>
                    <strong class="u-semi-bold">{{ product.DiscountPrice | currency(customerCurrencySymbol) }}</strong>
                </strong>
                <svgicon width=".4em" height=".4em" name="arrow-rounded" class="c-product-line__arrow svg-down" :class="{'is-open': open}"></svgicon>
            </div>
        </button>
        <div class="c-product-line__content" v-show="open">
            <div class="c-product-line-sizes o-spacing-small" :class="{'c-product-line-sizes_pants': isSizePants}">

                <template v-if="isSizePants">
                    <v-shop-product-pants-sizes :items="product.Variants" :waist-sizes="product.VariantsDim1" :length-sizes="product.VariantsDim2"></v-shop-product-pants-sizes>
                </template>

                <template v-else>
                    <v-shop-product-size-input v-for="variant in product.Variants[0]" :item="variant" :key="variant.Id"></v-shop-product-size-input>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VShopProductSizeInput from '@/components/shop/ShopProductSizeInput'
    import VShopProductPantsSizes from '@/components/shop/ShopProductPantsSizes'

    export default {
        props: {
            product: Object
        },
        components: {
            VShopProductSizeInput,
            VShopProductPantsSizes
        },
        data() {
            return {
                open: false,
                isSizePants: this.product.SizeChartId === 2
            }
        },
        computed: {
            isCustomerHidden() {
                return this.$store.getters.isCustomerHidden;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            },
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        methods: {
            toggleProduct() {
                this.open = !this.open;
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-product-line--customer {
        border: 1px solid palette(color-neutral, medium);

        &:not(:last-child) {
            margin-bottom: em($global-spacing-unit-small);
        }

        &.is-open {
            border-color: palette(color-neutral, medium-dark);
        }
    }

    .c-product-line__arrow{
        justify-self: flex-end;
        fill: $color-alpha;

        &.is-open{
            transform: rotate(-90deg);
            fill: $color-neutral;
        }
    }

    .c-product-line-header {
        padding: em($global-spacing-unit-small) em($global-spacing-unit);

        display: flex;
        flex-wrap: wrap;
        > * {
            flex: 0 0 (100%/6);
        }

        @supports (display: grid) {
            display: grid;
            grid-template-columns: 60px 300px auto;
            grid-auto-flow: column;
            align-items: center;
            grid-gap: em($global-spacing-unit);
        }

        img {
            width: 60px;
        }

        &__item {
            color: palette(color-base, medium);
            line-height: 1.25;
            em {
                font-style: normal;
                display: block;
                @include rfs($font-size-tiny);
            }
            strong{
                font-weight: $medium;
            }
        }
    }

    .c-product-line__content {
        border-top: 1px solid palette(color-neutral, medium);
        padding-top: em($global-spacing-unit-small);
        margin: 0 em($global-spacing-unit-small) em($global-spacing-unit) em($global-spacing-unit-small);
    }

    .c-product-line-sizes {
        display: flex;
        flex-wrap: wrap;
    }

    .c-product-line-sizes_pants {
        flex-wrap: nowrap;
        overflow-x: auto;
    }

</style>



// WEBPACK FOOTER //
// src/components/shop/ProductLine.vue